<div class="ion-padding modul-tema">
  <h2><ion-icon name="color-palette-outline"></ion-icon> Modulok témája</h2>
  <p class="halvany">
    Az intézmény moduljai kétféle keretben jelenhetnek meg. Az itt beállított kialakítás
    <b>mindenkire érvényes</b> ebben az intézményben<span *ngIf="intezmenyNev"> ({{ intezmenyNev }})</span>;
    a modul adminja vagy az általános adminisztrátor állíthatja.
  </p>

  <div class="jelmagyarazat">
    <div class="tema" *ngFor="let t of temak">
      <ion-icon [name]="t.ikon"></ion-icon>
      <div><b>{{ t.nev }}</b><br><small class="halvany">{{ t.leiras }}</small></div>
    </div>
  </div>

  <div *ngIf="betolt" class="halvany">Betöltés…</div>
  <ion-note *ngIf="hiba" color="danger">{{ hiba }}</ion-note>

  <ion-card *ngIf="!betolt && sorok.length">
    <ion-card-content>
      <div class="tabla-wrap">
        <table class="lista">
          <thead>
            <tr><th>Modul</th><th>Kialakítás</th><th></th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of sorok">
              <td class="modul">
                <img [src]="s.ikon" alt="" width="24" height="24">
                <b>{{ s.nev }}</b>
              </td>
              <td>
                <ng-container *ngIf="s.fokuszKepes; else nincsFokusz">
                  <ion-segment [value]="s.kijelolt" [disabled]="!s.admin || s.fut"
                               (ionChange)="beallit(s, '' + $event.detail.value)">
                    <ion-segment-button *ngFor="let t of temak" [value]="t.kod">
                      <ion-label>{{ t.nev }}</ion-label>
                    </ion-segment-button>
                  </ion-segment>
                  <small class="halvany" *ngIf="!s.beallitott">alapérték – az admin még nem döntött</small>
                </ng-container>
                <ng-template #nincsFokusz>
                  Klasszikus <span class="halvany">– ennél a modulnál még nincs Fókusz-kialakítás</span>
                </ng-template>
              </td>
              <td class="jobb">
                <ion-button *ngIf="s.fokuszKepes && s.beallitott && s.admin" size="small" fill="clear"
                            [disabled]="s.fut" (click)="beallit(s, '')">
                  <ion-icon slot="start" name="refresh-outline"></ion-icon>
                  Alapérték
                </ion-button>
                <ion-badge *ngIf="s.fokuszKepes && !s.admin" color="medium">csak olvasható</ion-badge>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <p *ngIf="!betolt && sorok.length && !vanAdmin" class="halvany">
    A kialakítást a modul adminja vagy az általános adminisztrátor módosíthatja – neked ezek csak olvashatók.
  </p>
  <p *ngIf="!betolt && sorok.length" class="halvany">
    <small>A változás a modul következő megnyitásakor (oldal-újratöltéskor) lép életbe.</small>
  </p>
</div>
